import React from 'react';
import {Icon} from "react-materialize";
import styled from "styled-components";

const StyledOptions = styled.div`
  color: #bababa;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  
  .edit {
    :hover {
      color: ${(props) => props.hoverColor};
    }
  }
  
  .delete {
    :hover {
      color: red;
    }
  }
`

const EditOptions = ({handleEdit, handleDelete, hoverColor='#3388BD'}) => {
  return (
    <StyledOptions hoverColor={hoverColor}>
      <Icon onClick={handleEdit} className={'edit'}>edit</Icon>
      <Icon onClick={handleDelete} className={'delete'}>delete_forever</Icon>
    </StyledOptions>
  )
}

export default EditOptions;